import { render, staticRenderFns } from "./CanaryWharfGroup.vue?vue&type=template&id=fde67bfc&scoped=true&"
import script from "./CanaryWharfGroup.vue?vue&type=script&lang=js&"
export * from "./CanaryWharfGroup.vue?vue&type=script&lang=js&"
import style0 from "./CanaryWharfGroup.vue?vue&type=style&index=0&id=fde67bfc&lang=less&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde67bfc",
  null
  
)

export default component.exports